// extracted by mini-css-extract-plugin
module.exports =  {"sub-header":"ccfda6eb9f--sub-header--PgXoK"};